import type { QueryOptionsOverride } from '../queryOptions.helpers';
import type { UserQuestListDto, UserQuestParams } from './userQuest.schema';
import { queryOptions } from '@tanstack/react-query';
import { QueriesKeys } from '../queriesKeys';
import { questsApi } from './userQuest.api';

export const questsQueryOptions = {
  userMeQuests: (params?: UserQuestParams, options?: QueryOptionsOverride<UserQuestListDto>) => queryOptions({
    queryKey: [QueriesKeys.mePlayerQuests, params],
    // TODO: remove limit when API will be ready, now it returns max 100 quests
    // but we need to get quests by type (DAILY, WEEKLY, MONTHLY), now it's not done from BE side
    queryFn: () => questsApi.getMeQuests({
      limit: 100,
      ...params,
    }),
    ...options,
  }),

};
